import api from './api.js'

// Workflow Service
export const workflowService = {
  async getByProspect(prospectId) {
    const response = await api.get(`/workflow/${prospectId}`)
    return response.data.success ? response.data.data : null
  },

  async getPending(params = {}) {
    const response = await api.get('/workflow/pending', { params })
    return response.data.success ? response.data.data : []
  },

  async getUrgent(params = {}) {
    const response = await api.get('/workflow/urgent', { params })
    return response.data.success ? response.data.data : []
  },

  async markUrgent(prospectId, _userInfo, { responsible_team_id } = {}) {
    const response = await api.post(`/workflow/${prospectId}/mark-urgent`, {
      send_notification: true,
      responsible_team_id
    })
    return response.data
  },

  async getMySubmissions(email) {
    const response = await api.get('/workflow/my-submissions', { params: { email } })
    return response.data.success ? response.data.data : []
  },

  async getRecent(limit = 10) {
    const response = await api.get('/workflow/recent', { params: { limit } })
    return response.data.success ? response.data.data : []
  },

  async getHistory(prospectId) {
    const response = await api.get(`/workflow/${prospectId}/history`)
    return response.data.success ? response.data.data : []
  },

  async submit(prospectId, _userInfo, { responsible_team_id } = {}) {
    const response = await api.post(`/workflow/${prospectId}/submit`, {
      responsible_team_id
    })
    return response.data
  },

  async approve(prospectId, _userInfo, comment = null) {
    const response = await api.post(`/workflow/${prospectId}/approve`, {
      comment
    })
    return response.data
  },

  async discuss(prospectId, _userInfo, comment = null) {
    const response = await api.post(`/workflow/${prospectId}/discuss`, {
      comment
    })
    return response.data
  },

  async reject(prospectId, _userInfo, feedback, suggestedEmployees = []) {
    const response = await api.post(`/workflow/${prospectId}/reject`, {
      feedback,
      suggested_employees: suggestedEmployees
    })
    return response.data
  },

  async resubmit(prospectId, _userInfo, comment = null, { responsible_team_id } = {}) {
    const response = await api.post(`/workflow/${prospectId}/resubmit`, {
      comment,
      responsible_team_id
    })
    return response.data
  },

  async sourcingReject(prospectId, _userInfo, reason) {
    const response = await api.post(`/workflow/${prospectId}/sourcing-reject`, {
      reason
    })
    return response.data
  },

  async reassess(prospectId, _userInfo, reason) {
    const response = await api.post(`/workflow/${prospectId}/reassess`, {
      reason
    })
    return response.data
  },

  async updateResponsibleTeam(prospectId, responsibleTeamId) {
    const response = await api.patch(`/workflow/${prospectId}/responsible-team`, {
      responsible_team_id: responsibleTeamId
    })
    return response.data
  },

  async heraanvraag(prospectId, _userInfo, feedback) {
    const response = await api.post(`/workflow/${prospectId}/heraanvraag`, {
      feedback
    })
    return response.data
  },

  async getUnprocessedCount() {
    const response = await api.get('/workflow/unprocessed-count')
    return response.data.success ? response.data.data.count : 0
  },

  async getNavBadges(params = {}) {
    const response = await api.get('/workflow/nav-badges', { params })
    return response.data.success ? response.data.data : null
  }
}
